import styled from "@emotion/native"
import { Text } from "./Typography"

type ButtonProps = {
  title: string
  lowercase?: boolean
  onPress?: () => void
  testID?: string
}

export function PayButton(props: ButtonProps) {
  const { title, lowercase, onPress, testID } = props

  return (
    <StyledTouchableOpacity
      onPress={onPress}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={title}
    >
      <Text type="secondaryButton" color="royalBlue">
        {lowercase ? title : title.toUpperCase()}
      </Text>
    </StyledTouchableOpacity>
  )
}

const StyledTouchableOpacity = styled.TouchableOpacity`
  background-color: ${({ theme }) => theme.button.pay.backgroundColor};
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  border-width: 0;
  padding: 11px 12px 11px 12px;
`
